import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { getValidLanguageTagForMoment } from '../../../commonFunctions';
import { SensorStatusCircle } from '../../../components/sensors/SensorStatusDot';
import { DeviceTypeNames, EnumStatusColors } from '../../../models/commonEnums';
import { AnyDeviceType } from '../../../models/commonTypeScript';

type Props = {
    segmentName: string;
    latestSample?: string;
    serialNumber: string;
    tileStatus: EnumStatusColors;
    deviceType: AnyDeviceType;
};

const DeviceListHeader = ({
    segmentName,
    latestSample,
    serialNumber,
    tileStatus,
    deviceType,
}: Props): React.ReactElement => {
    const { t: txt } = useTranslation();
    const language = getValidLanguageTagForMoment();
    const lastSynced = latestSample ? moment.utc(latestSample).local().locale(language).fromNow() : txt('neverSynced');
    return (
        <div className="list-tile__header">
            <div className="list-tile__header__section">
                <SensorStatusCircle color={tileStatus} />
            </div>
            <div className="list-tile__header__section">
                <div className="list-tile__header__title">
                    <h2 className="list-tile__header__title--name">{segmentName}</h2>
                    <span className="tile-header__title--address">{serialNumber}</span>
                    {deviceType !== DeviceTypeNames.ap1 && (
                        <div className="list-tile__header__last-synced">{[txt('LastSynced'), ' ', lastSynced]}</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DeviceListHeader;
